import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

const SimpleVideos = ({ title = '', videos = [] }) => {
  return (
    <div className="simple-videos">
      {title && <div className="simple-videos__title">{title}</div>}
      {videos && (
        <div className="simple-videos__items">
          {videos.map(
            (video, index) =>
              video.videoUrl && (
                <div
                  key={`simple-video-${index}`}
                  className="simple-videos__item"
                >
                  <VideoPlayer {...video} />
                  {video.title && (
                    <div className="simple-videos__item-title">
                      {video.title}
                    </div>
                  )}
                  {video.caption && (
                    <p className="simple-videos__item-caption">
                      {video.caption}
                    </p>
                  )}
                </div>
              )
          )}
        </div>
      )}
    </div>
  );
};

export default SimpleVideos;
